import { render, staticRenderFns } from "./CopyFromBranch.vue?vue&type=template&id=699d7348"
import script from "./CopyFromBranch.vue?vue&type=script&lang=js"
export * from "./CopyFromBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports